module.exports = __webpack_public_path__ + "Title.png";